import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import numeral from 'numeral';
import Highcharts from 'highcharts';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import HighchartsReact from 'highcharts-react-official';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// Components
// import GroupCard from '../../components/GroupCard';

// Actions
import { gameActions } from '../../actions';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';
// import infoModal from '../../assets/info-modal-1.png';

NoDataToDisplay(Highcharts);

// INLINE COMPONENTS
const LearningCurveChart = ({ data }) => {
  const chartOptions = {
    chart: {
      type: 'line',
      height: 400,
      backgroundColor: 'transparent',
    },
    credits: {
      enabled: false,
    },
    title: {
      text: '',
    },
    xAxis: {
      title: {
        text: 'N-th Loan Application',
      },
      min: 1,
      // max: 49,
      tickInterval: 1,
      // offset: 1,
      labels: {
        formatter: function () {
          const ordinal =
            this.value === 1
              ? 'st'
              : this.value === 2
              ? 'nd'
              : this.value === 3
              ? 'rd'
              : 'th';
          return `${this.value}${ordinal}`;
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Average Elapsed Time (seconds)',
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      headerFormat:
        '<span style="font-size:12px">{point.key}{series.chart.axes[0].tickPositioner.ordinal}</span><br/>',
      pointFormat:
        '<span style="color:{series.color}">Average Total Time: </span>' +
        '<b>{point.y:.2f} seconds</b><br/>',
      formatter: function () {
        const ordinal =
          this.x === 1
            ? 'st'
            : this.x === 2
            ? 'nd'
            : this.x === 3
            ? 'rd'
            : 'th';
        return `<span style="font-size:12px">${
          this.x
        }${ordinal} Task Submitted</span><br/>
                <span style="color:${
                  this.series.color
                }">Average Total Time: </span>
                <b>${this.y.toFixed(2)} seconds</b><br/>`;
      },
    },
    series: [
      {
        name: 'Average Time',
        data: data,
        marker: {
          enabled: true,
          radius: 3,
        },
        lineWidth: 2,
      },
    ],
    noData: {
      style: {
        fontSize: '16px',
        color: '#666',
      },
      position: {
        align: 'center',
        verticalAlign: 'middle',
      },
    },
  };

  return (
    <div className='learning-curve-chart'>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{ style: { height: '400px', width: '100%' } }}
      />
    </div>
  );
};

class DebriefLearningCurve extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item || null,
      filter_group: null,
    };
  }

  componentDidMount() {
    const { dispatch, match, game } = this.props;
    if (match.params.id && !game?.data?._id) {
      dispatch(gameActions.fetchGames(match.params.id));
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      item: newProps.item,
    });
  }

  render() {
    const { game } = this.props;
    const gameData = game.data;

    // Tasks list
    const tasksNames = [
      'front-ratio',
      'back-ratio',
      'loan-to-value',
      'risk-assessment',
      'decision',
    ];

    // Filter by group if selected
    const { filter_group } = this.state;
    const selectedGroups = filter_group
      ? gameData?.groups.filter((g) => g._id === filter_group)
      : gameData?.groups || [];

    // Calculate learning curve data for each task
    const learningCurveData = tasksNames.map((taskName) => {
      // Get all items for this task across all groups
      const taskItems =
        selectedGroups?.flatMap(
          (g) => g?.items?.filter((i) => i.activity === taskName) || []
        ) || [];

      // Sort decision items by created_at to get completion order
      taskItems.sort((a, b) => {
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        return dateA - dateB;
      });

      // Group by application ID and calculate average elapsed time
      const applicationData = {};

      taskItems.forEach((item) => {
        // Extract application ID from item
        const applicationId = item.application;

        if (applicationId && applicationId >= 1 && applicationId <= 49) {
          let elapsed = 0;

          // Calculate elapsed time (elapsed_time is in milliseconds, convert to seconds)
          if (item.elapsed_time) {
            elapsed = item.elapsed_time / 1000;
          } else if (item.created_at && item.started_at) {
            elapsed =
              (new Date(item.created_at) - new Date(item.started_at)) / 1000;
          }

          if (!applicationData[applicationId]) {
            applicationData[applicationId] = {
              totalTime: 0,
              count: 0,
            };
          }

          applicationData[applicationId].totalTime += elapsed;
          applicationData[applicationId].count += 1;
        }
      });

      // Convert to chart data format
      // const chartData = [];
      const avgTimes = Object.entries(applicationData).map(([id, data]) => {
        return [id, data.totalTime / data.count];
      });

      return {
        task: taskName,
        data: avgTimes,
      };
    });

    return (
      <div>
        <Header />

        {/* <h2 className='mt-3 sec-title fs-3'>
          Learning Curve: Task{' '}
          <small className='float-end'>
            <DebriefMenu
              game_id={game.data._id}
              location={this.props.location}
            />
          </small>
        </h2> */}

        <h2 className='d-flex mt-3 sec-title fs-3'>
          <span className='d-none d-xl-inline text-nowrap'>
            Learning Curve: Task
          </span>
          {/* Display sub-menu on larger viewports */}
          <DebriefMenu
            className='small d-flex justify-content-between justify-content-xl-end align-items-center ms-xl-auto w-100'
            game_id={game.data._id}
            location={this.props.location}
          />
        </h2>

        <div className='row mt-3'>
          <div className='col-12 mb-2'>
            <p className='text-center'>
              Each chart shows the average elapsed time for each loan
              application across all groups.
            </p>

            {/* Group Selector */}
            <select
              className='form-select form-select-sm w-auto mx-auto mb-2'
              onChange={(e) => {
                const { value } = e.target;
                this.setState({ filter_group: value });
              }}>
              <option value=''>All Groups</option>
              {gameData?.groups?.map((g, i) => {
                const groupName = g.name.length > 0 ? g.name : `Group ${i + 1}`;
                return (
                  <option key={`group-${i}`} value={g._id}>
                    {groupName}
                  </option>
                );
              })}
            </select>
          </div>

          {/* CHARTS */}
          <div className='col-12'>
            <div className='d-flex gap-3 justify-content-between'>
              {/* FRONT-RATIO */}
              <div className='mb-4 pt-3 w-100 shadow bg-white border text-center'>
                <h3 className='h6 fw-bold'>Front Ratio</h3>
                <LearningCurveChart
                  data={
                    learningCurveData.find((d) => d.task === 'front-ratio')
                      ?.data || []
                  }
                />
              </div>

              {/* BACK-RATIO */}
              <div className='mb-4 pt-3 w-100 shadow bg-white border text-center'>
                <h3 className='h6 fw-bold'>Back Ratio</h3>
                <LearningCurveChart
                  data={
                    learningCurveData.find((d) => d.task === 'back-ratio')
                      ?.data || []
                  }
                />
              </div>

              {/* LOAN-TO-VALUE */}
              <div className='mb-4 pt-3 w-100 shadow bg-white border text-center'>
                <h3 className='h6 fw-bold'>Loan to Value</h3>
                <LearningCurveChart
                  data={
                    learningCurveData.find((d) => d.task === 'loan-to-value')
                      ?.data || []
                  }
                />
              </div>
            </div>

            <div className='d-flex gap-3 justify-content-center mx-5 px-5 mb-5'>
              {/* RISK-ASSESSMENT */}
              <div className='mb-4 pt-3 w-50 shadow bg-white border text-center'>
                <h3 className='h6 fw-bold'>Risk Assessment</h3>
                <LearningCurveChart
                  data={
                    learningCurveData.find((d) => d.task === 'risk-assessment')
                      ?.data || []
                  }
                />
              </div>

              {/* DECISION */}
              <div className='mb-4 pt-3 w-50 shadow bg-white border text-center'>
                <h3 className='h6 fw-bold'>Decision</h3>
                <LearningCurveChart
                  data={
                    learningCurveData.find((d) => d.task === 'decision')
                      ?.data || []
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { player, game } = state;
  return {
    game,
    player,
  };
}

export default connect(mapStateToProps)(DebriefLearningCurve);
